

































































































































































































































































































import Vue from 'vue'
import vClickOutside from 'v-click-outside'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import CLegacySelectClearAllButton from './CLegacySelectClearAllButton.vue'
/**
 * @deprecated Use the CCustomSelect component instead
 */
export default Vue.extend({
  components: { CLegacySelectClearAllButton },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    header: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    highlightText: {
      type: Boolean,
      required: false,
      default: false
    },
    value: { type: [Object, String, Number, Array], default: null },
    placeholder: {
      type: String,
      default() {
        return this.$t('select an option')
      }
    },
    options: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    floatingPlaceholder: { type: Boolean, default: false, required: false },
    maxHeight: { type: Number, default: 300 },
    multiSelect: { type: Boolean },
    maxToShow: { type: Number, default: 2 },
    nameString: { type: String, default: 'name' },
    countString: { type: String, default: 'count' },
    valueString: { type: String, default: 'value' },
    optGroup: { type: Boolean },
    searchable: { type: Boolean },
    showActions: { type: Boolean },
    clearOnly: { type: Boolean, default: false },
    disabled: { type: Boolean },
    noUnselect: { type: Boolean },
    tabIndex: { type: Number, default: 0 },
    label: { type: String, required: false, default: '' },
    variant: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      icons: {
        check: faCheck
      },
      selected: this.multiSelect
        ? this.value != null
          ? this.value
          : []
        : this.value, // this is a bit hard to read
      openDropdown: false,
      prefferedOpenDirection: 'below',
      optimizedHeight: this.maxHeight,
      searchString: '',
      noSearchOptions: false,
      currentlyHighlighted: this.optGroup
        ? { optgroup: null, option: null }
        : null,
      mouseDown: false
    }
  },
  computed: {
    showClearAllButton() {
      return this.multiSelect && this.selected.length
    },
    selectedName() {
      // this is kinda way too complex, maybe find another way??
      let nameConcat = ''

      if (this.selected && !this.disabled && this.options) {
        for (let i = 0; i < this.options.length; i++) {
          if (!this.multiSelect) {
            if (this.optGroup) {
              for (let o = 0; o < this.options[i].values.length; o++) {
                if (
                  this.options[i].values[o][this.valueString] === this.selected
                ) {
                  return this.options[i].values[o][this.nameString].toString()
                }
              }
            } else if (this.options[i][this.valueString] === this.selected) {
              if (this.options[i]['head-name']) {
                return this.options[i]['head-name'].toString()
              } else {
                return this.options[i][this.nameString].toString()
              }
            }
          } else if (this.optGroup) {
            for (let o = 0; o < this.options[i].values.length; o++) {
              for (let j = 0; j < this.selected.length; j++) {
                if (
                  this.options[i].values[o][this.valueString] ===
                  this.selected[j]
                ) {
                  if (nameConcat !== '') {
                    // if we already added an option, add the coma
                    nameConcat += ', '
                  }
                  nameConcat += this.options[i].values[o][
                    this.nameString
                  ].toString()
                }
              }
            }
          } else {
            for (let j = 0; j < this.selected.length; j++) {
              if (this.options[i][this.valueString] === this.selected[j]) {
                if (nameConcat !== '') {
                  // if we already added an option, add the coma
                  nameConcat += ', '
                }
                nameConcat += this.options[i][this.nameString].toString()
              }
            }
          }
        }
      }

      if (this.multiSelect) {
        return nameConcat
      }

      return null
    },
    isMobile() {
      return !this.$ua.isFromPc()
    }
  },
  watch: {
    searchString(value) {
      this.searchOptions(value)
    },
    value(value) {
      this.selected = this.multiSelect ? (value != null ? value : []) : value
    }
  },
  created() {},
  updated() {},
  mounted() {
    if (!this.isMobile) {
      this.$refs.vdropdown.addEventListener('keydown', this.navigate)
    }
  },
  methods: {
    optionClicked(val) {
      if (this.multiSelect) {
        const index = this.selected.indexOf(val)
        if (index > -1) {
          // if its already in the array, remove it
          this.selected.splice(index, 1)
        } else {
          // else add it
          this.selected.push(val)
        }
      } else {
        if (this.selected === val && !this.noUnselect) {
          this.selected = null
        } else {
          this.selected = val
        }
        this.closeDropdown()
      }
      this.updateValue()
    },
    valueInSelected(i) {
      if (this.multiSelect) {
        if (this.selected.includes(i)) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    clickOutside(e) {
      const element = this.$refs.carzillaSelectHeader
      if (
        this.$refs.vdropdown &&
        this.$refs.vdropdown.style.display !== 'none' &&
        e.target !== element
      ) {
        this.closeDropdown()
      }
    },
    closeDropdown() {
      this.openDropdown = false
      this.prefferedOpenDirection = 'below'
      this.searchString = ''
      this.clearHighlighted()
    },
    toggleDropdown() {
      if (!this.disabled) {
        if (!this.isMobile || (this.isMobile && this.searchable)) {
          if (this.openDropdown) {
            // it's open, close it
            this.closeDropdown()
          } else {
            this.openDropdown = true
            this.adjustPosition()
            if (!this.optGroup && !this.searchable) {
              this.fixOverflow(this.options.indexOf(this.selected))
            }
          }
        }
      }
    },
    selectFocus() {
      if (!this.mouseDown && !this.openDropdown) {
        // we got focus, but not from click (probably tab)
        this.toggleDropdown()
      }
    },
    selectBlur() {
      if (!this.disabled && !this.mouseDown) {
        if (!this.isMobile || (this.isMobile && this.searchable)) {
          if (this.openDropdown) {
            // it's open, close it
            this.closeDropdown()
          }
        }
      }
    },
    navigate(e) {
      // complex stuff again :(

      const code = event.keyCode
      if (code === 38 || code === 40) {
        e.preventDefault()
        if (this.optGroup) {
          if (
            this.currentlyHighlighted.optgroup == null &&
            this.currentlyHighlighted.option == null
          ) {
            this.currentlyHighlighted = {
              optgroup: 0,
              option: 0
            }
          } else if (code === 38) {
            this.currentlyHighlighted.option--
            if (this.currentlyHighlighted.option < 0) {
              this.currentlyHighlighted.optgroup--
              if (this.currentlyHighlighted.optgroup < 0) {
                this.currentlyHighlighted.optgroup = this.options.length - 1
              }
              this.currentlyHighlighted.option =
                this.options[this.currentlyHighlighted.optgroup].values.length -
                1
            }
          } else if (code === 40) {
            this.currentlyHighlighted.option++
            if (
              this.currentlyHighlighted.option >
              this.options[this.currentlyHighlighted.optgroup].values.length - 1
            ) {
              this.currentlyHighlighted.optgroup++
              if (
                this.currentlyHighlighted.optgroup >
                this.options.length - 1
              ) {
                this.currentlyHighlighted.optgroup = 0
              }
              this.currentlyHighlighted.option = 0
            }
          }

          // if selected option is hidden rerun the method
          if (
            this.options[this.currentlyHighlighted.optgroup].values[
              this.currentlyHighlighted.option
            ].hide &&
            !this.noSearchOptions
          ) {
            this.navigate(e)
          }
        } else {
          if (this.currentlyHighlighted == null) {
            this.currentlyHighlighted = 0
          } else if (code === 38) {
            this.currentlyHighlighted--
            if (this.currentlyHighlighted < 0) {
              this.currentlyHighlighted = this.options.length - 1
            }
          } else if (code === 40) {
            this.currentlyHighlighted++
            if (this.currentlyHighlighted > this.options.length - 1) {
              this.currentlyHighlighted = 0
            }
          }

          if (
            this.options[this.currentlyHighlighted].hide &&
            !this.noSearchOptions
          ) {
            this.navigate(e)
          }
        }

        // navigate is done, check if highlighted elem is not hidden by overflow
        this.fixOverflow(this.currentlyHighlighted)
      }

      if (code === 13) {
        // enter
        if (
          (this.currentlyHighlighted.optgroup != null &&
            this.currentlyHighlighted.option != null) ||
          this.currentlyHighlighted != null
        ) {
          if (this.optGroup) {
            this.optionClicked(
              this.options[this.currentlyHighlighted.optgroup].values[
                this.currentlyHighlighted.option
              ][this.valueString]
            )
          } else {
            this.optionClicked(
              this.options[this.currentlyHighlighted][this.valueString]
            )
          }
        }
      }
    },
    clearHighlighted() {
      if (this.optGroup) {
        this.currentlyHighlighted = { optgroup: null, option: null }
      } else {
        this.currentlyHighlighted = null
      }
    },
    fixOverflow(opt) {
      if (opt != null) {
        if (opt < 0) {
          // for whatever reason
          return
        }

        let elem = null
        if (this.optGroup) {
          elem = this.$refs['option-' + opt.optgroup + '-' + opt.option][0]
        } else {
          elem = this.$refs['option-' + opt][0]
        }

        if (this.searchable) {
          if (
            elem.offsetTop - this.$refs.vsearchboxcont.clientHeight <
              this.$refs.vdlist.scrollTop ||
            elem.offsetTop - this.$refs.vsearchboxcont.clientHeight >=
              this.$refs.vdlist.scrollTop +
                parseInt(this.$refs.vdlist.style.maxHeight, 10)
          ) {
            this.$refs.vdlist.scrollTop =
              elem.offsetTop - this.$refs.vsearchboxcont.clientHeight
          }
        } else if (
          elem.offsetTop < this.$refs.vdlist.scrollTop ||
          elem.offsetTop >=
            this.$refs.vdropdown.scrollTop +
              parseInt(this.$refs.vdlist.style.maxHeight, 10)
        ) {
          this.$refs.vdlist.scrollTop = elem.offsetTop
        }
      }
    },
    adjustPosition() {
      this.$nextTick(() => {
        if (typeof window !== 'undefined') {
          // const t = this.$refs.vdropdown.getBoundingClientRect().top
          const e =
            window.innerHeight -
            this.$refs.vdropdown.getBoundingClientRect().bottom

          if (e > 0) {
            this.prefferedOpenDirection = 'below'
            // this.optimizedHeight = Math.min(e - 40, this.maxHeight);
          } else {
            this.prefferedOpenDirection = 'above'
            // this.optimizedHeight = Math.min(t - 40, this.maxHeight)
          }

          if (this.searchable) {
            this.$refs.vsearchbox.focus()
          } else {
            this.$refs.vdropdown.focus()
          }
        }
      })
    },
    searchOptions(val) {
      let found = false
      for (let i = 0; i < this.options.length; i++) {
        if (this.optGroup) {
          for (let opt = 0; opt < this.options[i].values.length; opt++) {
            if (
              this.options[i].values[opt].name
                .toLowerCase()
                .search(
                  val.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                ) < 0
            ) {
              this.options[i].values[opt].hide = true
            } else {
              this.options[i].values[opt].hide = false
              found = true
            }
          }

          // one more loop to hide group if all are hidden
          let counter = 0
          for (let opt = 0; opt < this.options[i].values.length; opt++) {
            if (this.options[i].values[opt].hide) {
              counter++
            }
          }

          if (counter === this.options[i].values.length) {
            this.options[i].hide = true
          } else {
            this.options[i].hide = false
          }
        } else {
          // search name

          let nameIndex = -1
          let valueIndex = -1
          if (val !== '') {
            nameIndex = this.options[i][this.nameString]
              .toString()
              .toLowerCase()
              .search(val.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
            valueIndex = this.options[i][this.valueString]
              .toString()
              .toLowerCase()
              .search(val.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))

            if ((nameIndex < 0) & (valueIndex < 0)) {
              this.options[i].hide = true
            } else {
              this.options[i].hide = false
              found = true
            }
          } else {
            this.options[i].hide = false
            this.noSearchOptions = false
          }
        }
      }

      if (val !== '') {
        if (!found) {
          this.noSearchOptions = true
        } else {
          this.noSearchOptions = false
        }
      }
    },
    clearAll() {
      this.selected = []
      this.updateValue()
    },
    selectAll() {
      if (this.optGroup) {
        for (let i = 0; i < this.options.length; i++) {
          for (let opt = 0; opt < this.options[i].values.length; opt++) {
            this.selected.push(this.options[i].values[opt].value)
          }
        }
      } else {
        this.selected = this.options
      }
      this.updateValue()
    },
    updateValue() {
      this.$emit('input', this.selected)
      this.$emit('change', this.selected)
    }
  }
})
